import { render, staticRenderFns } from "./vipTip.vue?vue&type=template&id=16c6a4fa&scoped=true"
import script from "./vipTip.vue?vue&type=script&lang=js"
export * from "./vipTip.vue?vue&type=script&lang=js"
import style0 from "./vipTip.vue?vue&type=style&index=0&id=16c6a4fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6a4fa",
  null
  
)

export default component.exports